import { combineReducers } from 'redux';
import dialogs from './dialogs';
import kbApp from './kbAppReducer';
import dailyTask from './dailyTask';
import dailyTaskRaw from './dailyTaskRaw';
import myIntegral from './myIntegral';
import bindCodeData from './bindCodeData';
import signTask from './signTask';
import isNewUser from './isNewUser';
import preProcess from './preProcess';
import hasInviteCard from './hasInviteCard';
import isLogin from './isLogin';
import credit from './credit';
import testBucket from './testBucket';
import { isShowTaotie, isShowTaotieSwing, propertyTransAnim } from './common';
import nightMode from './nightMode';
import withdrawMinimun from './withdrawMinimun';
import { springTask, curTime } from './springAct';

export default combineReducers({
  dialogs,
  kbApp,
  dailyTask,
  myIntegral,
  bindCodeData,
  signTask,
  isNewUser,
  preProcess,
  hasInviteCard,
  isLogin,
  credit,
  testBucket,
  isShowTaotie,
  isShowTaotieSwing,
  propertyTransAnim,
  nightMode,
  withdrawMinimun,
  springTask,
  curTime,
  dailyTaskRaw,
});
